import { Rpc } from '../rpc';
import { RpcObservableServer } from '../rpc-observable-server';
import {
    RpcObservableElevateError, RpcObservableElevateKey, RpcObservableElevateRequest, RpcObservableElevateResult
} from './rpc-observable-elevate-model';

export class RpcObservableElevateServer
    extends RpcObservableServer<RpcObservableElevateRequest, RpcObservableElevateResult, RpcObservableElevateError> {

    /**
     * Initializes a new instance of the RpcObservableElevateServer class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableElevateKey.command, RpcObservableElevateKey.version);
    }
}
